/*** IMPORTS FROM imports-loader ***/
(function() {

define([
	'jquery',
	'mustache',
	'pip-model',
	'pip-events',
	'thd-overlay',
	'paint-data',
	'paint_carousel',
	'paint-calculator',
	'window'
],
	function (
		$,
		Mustache,
		pip,
		pipEvents,
		thdOverlay,
		paintData,
		paintCarousel,
		paintCalculator,
		window
	) {

  var FUNCTIONAL_DETAILS = 'functional details',
    NOT_DISPLAYED = 'notDisplayed',
    INTERIOR_EXTERIOR_GUID = '90d831e8-c8f3-454b-8684-3d9166bfe567',
    COLOR_FINISH_GUID = 'aacb73e8-7810-4d9e-8f23-e5ac86ef7f3f',
    COLOR_NUMBER_GUID = 'bb10c3a6-2ae5-4988-af26-9c4aa2d0211e',
    RGB_VALUE_GUID = 'd3aaa2df-e13a-4f76-a06f-dddaeda235e5',
    PAINT_BRAND_GUID = 'a6b3fd35-901f-4506-afaf-8b798895f64c',
    HELP_ME_CHOOSE_ANALYTICS_TARGET = 'Help me choose';

  var BRANDS_ALLOWED_KEYS = {
    "PPG - Glidden": "Glidden - PPG",
    "Glidden - PPG": "Glidden - PPG",
    "Behr": "Behr"
  };

  var STICKY_DESCRIPTION_CHAR_LIMIT = 50;



  var view = {
    selectors: {
      recommendationMessage: '.recommendation-message',
      overlay: {
        paintOverlay: '.paint-overlay',
        visible: 'paint-overlay__invisible'
      },
      wrapper: {
        default: '.buybox__super-sku-tile-wrapper',
        hidden: 'buybox__super-sku-tile-wrapper--hidden'
      },
      filters: {
        filter: '.product_sku_Overlay_ListBoxes .filter__item',
        disabled: 'filter__item--disabled',
        active: 'filter__item--active'
      },
      modals: {
        modal: '.paint-ssku-info-label',
        modalCross: '.modal-header__cross',
        modalWrapper: 'modal-body__wrapper',
        interiorBrandModalDisclaimer: '.interior-type__disclaimer'
      },
      data: {
        itemId: 'data-item-id',
        canonicalUrl: 'data-canonical-url'
      },
      stickyTile: {
        wrapper: '.sticky-tile',
        title: '.product-title__title'
      },
      calculateEstimate: {
        tab: '.calculator-estimator-container__tab',
        selectedTab: '.calculator-estimator-container__tab--selected',
        tabContent: '.tab-content',
        selectedTabContent: '.tab-content--selected',
        calculateButton: '.calculator-estimator-container .bttn__content',
        editMeasurementLink: '.measurement-link',
        estimateTab: '.estimate-tab',
        calculatorTab: '.calculator-tab',
        calculate: {
          formSection: '.tab-content__form-section',
          resultsSection: '.tab-content__results-section',
          resultsMessage: '#paint-calculator-results-message',
          height: '#paint-calculator__height',
          width: '#paint-calculator__width',
          length: '#paint-calculator__length',
          numberOfDoors: '#paint-calculator__number-of-doors',
          numberOfWindows: '#paint-calculator__number-of-windows'
        }
      }
    },
    templates: {
      modals: {
        paintType: $('#paint-types').html(),
        brandOptions: $('#brand-options').html(),
        sheenOptions: $('#sheen-options').html(),
      },
      selectedPaintBanner: $('#paint-banner').html(),
      modalHeader: $('#modal-header').html(),
      bar: $('#bar-option').html()
    },
    render: {
      paintType: function paintType(data) {
        return view.render.partial(view.templates.modals.paintType, data);
      },
      brandOptions: function brandOptions(data) {
        return view.render.partial(view.templates.modals.brandOptions, data);
      },
      sheenOptions: function sheenOptions(data) {
        return view.render.partial(view.templates.modals.sheenOptions, data);
      },
      calculateEstimate: function calculateEstimate(data) {
        return paintCalculator.renderer(data, {
          selectedPaintBanner: view.templates.selectedPaintBanner,
          modalHeader: view.templates.modalHeader
        });
      },
      partial: function renderPartial(modal, data) {
        return Mustache.render(modal, data, {
          selectedPaintBanner: view.templates.selectedPaintBanner,
          modalHeader: view.templates.modalHeader,
          bar: view.templates.bar
        });
      }
    },
    updateDOM: {
      pipPrice: function updatePipPrice(itemId) {
        if (pip.features.clientPriceLoadingEnabled
          && typeof window.addPriceToPage === 'function') {
          window.addPriceToPage(itemId);
        }
      },
      trimTitle: function trimTitle() {
        var titleSelector = view.selectors.stickyTile.wrapper + ' ' + view.selectors.stickyTile.title;
        var text = $(titleSelector).text();

        $(titleSelector).html(
          text.length > STICKY_DESCRIPTION_CHAR_LIMIT
          ? text.slice(0, STICKY_DESCRIPTION_CHAR_LIMIT) + '...'
          : text
        );
      },
      showStickyFooter: function showStickyFooter() {
        view.updateDOM.trimTitle();
        $(view.selectors.stickyTile.wrapper).addClass('trimmed');
      }
    },
    initDOMEventListeners: function initDOMEventListeners() {

      $(window.document).on('click.ssku touch.ssku', view.selectors.modals.modal, function (e) {
        e.preventDefault();

        var overlayContent = window.document.createElement('div')
        $(overlayContent).addClass('modal-body__wrapper');
        var modalType = model.modalTypes[$(this).data().modalType];

        viewModel.setTitle($(this).data().modalType);
        overlayContent.innerHTML = view.render[modalType](viewModel.modalData);

        pipEvents.ssku.modalOpen.trigger({
          component: model.titles[modalType],
          target: HELP_ME_CHOOSE_ANALYTICS_TARGET
        });

        var overlay = new thdOverlay({
          speed: '500ms',
          useContent: true,
          channel: pip.platformForCart,
          header: false,
          htmlNode: overlayContent,
          initialHeight: 300,
          closeButton: true,
        });

        overlay.open();
        viewModel.setInteriorTypeBrandModalDisclaimer();
        if (window.matchMedia("(max-width: 575px)").matches && model.hasSwipe[modalType]) {
          paintCarousel.init({
            swiperId: '#carousel',
            bullets: true
          });
        }
      });
    },
    init: function init() {
      view.initDOMEventListeners();
      paintCalculator.init();
    }
  };


  var model = {
    titles: {
      paintType: 'Paint Types',
      brandOptions: 'Brand Options',
      sheenOptions: 'Sheen Options',
      calculateEstimate: 'Calculate or Estimate',
    },
    modalTypes: {
      Paint: 'paintType',
      Brand: 'brandOptions',
      Sheen: 'sheenOptions',
      Container: 'calculateEstimate'
    },
    hasSwipe: {
      brandOptions: true,
      sheenOptions: true
    },
    brandOptionsName: {
      "Interior Paint": [
        { value: 'Performance' },
        { value: 'Coverage' },
        { value: 'Durability' },
        { value: 'Easy to clean' },
        { value: 'Stain Blocking' },
        { value: 'Odor & VOC Content' }
      ],
      "Exterior Paint": [
        { value: 'Performance' },
        { value: 'Coverage' },
        { value: 'Fade and UV protection' },
        { value: 'Dirt and mildew resistant' },
        { value: 'Resists cracking & peeling' },
      ],
    },
    init: function init() {
      var data = paintData.getPaintData();
      model.paintData = data;
    }
  };

  var viewModel = {
    modalData: {
      selectedPaint: {
        RGBValue: '',
        colorNumber: '',
        colorName: '',
        brandName: ''
      },
      brandData: {},
      estimateData: { estimatesPerRoom: [] },
      brandOptionsName: [],
    },
    loadWithTilesExpanded: false,
    setTitle: function setTitle(modalType) {
      var separator,
        suffix = '',
        isBrandModal = modalType === 'Brand'; //see model.modalTypes

      if (isBrandModal) {
        separator = window.matchMedia("(max-width: 575px)").matches ? ' | ' : ' - ';
        suffix = separator + viewModel.paintType;
      }
      viewModel.modalData.title = model.titles[model.modalTypes[modalType]] + suffix;
    },
    initParentBrandData: function initParentBrandData() {
      pip.products.primary.data.attributeGroups.filter(function (attrs) {
        return attrs.groupType === NOT_DISPLAYED;
      })[0].entries.forEach(function (entry) {
        if (entry.guid === PAINT_BRAND_GUID) {
          viewModel.modalData.selectedPaint.brandName = BRANDS_ALLOWED_KEYS[entry.value]
            || entry.value + ' key is missing inside brand objects inside paintData';
        }
      });
    },
    initSheenData: function initSheenData() {
      viewModel.modalData.sheenData = model.paintData.sheens.map(function (el) {
        return $.extend({}, el, {
          options: [{ value: el.washability }]
        });
      });
    },
    setInteriorTypeBrandModalDisclaimer: function setInteriorTypeBrandModalDisclaimer() {
      //TO DO: this needs to be added to the data model
      if(viewModel.paintType === 'Interior Paint') {
        $(view.selectors.modals.interiorBrandModalDisclaimer).removeClass('disabled');
      }
    },
    setPaintData: function setPaintData() {
      pip.products.primary.data.attributeGroups.filter(function (attrs) {
        return attrs.groupType === FUNCTIONAL_DETAILS;
      })[0].entries.forEach(function (entry) {

        if (entry.guid == INTERIOR_EXTERIOR_GUID) {
          viewModel.paintType = entry.value;
          viewModel.modalData.brandOptionsName = model.brandOptionsName[entry.value];
          viewModel.modalData.brandData = model.paintData.brands[viewModel.modalData.selectedPaint.brandName][entry.value].map(function (el) {
            return $.extend({}, el, {
              options: [{ value: el.durability }, { value: el.washability }, { value: el.stainBlocking }]
            });
          });
        }
        if (entry.guid == COLOR_FINISH_GUID) {
          viewModel.modalData.selectedPaint.colorName = entry.value;
        }
        if (entry.guid == RGB_VALUE_GUID) {
          //TODO - consider making a small utility function for the rgb value transfformation below
          viewModel.modalData.selectedPaint.RGBValue = ['rgb(', entry.value.split(':').join(','), ')'].join('');
        }
        if (entry.guid == COLOR_NUMBER_GUID) {
          viewModel.modalData.selectedPaint.colorNumber = entry.value;
        }
      });
      viewModel.modalData.estimateData.estimatesPerRoom = [];
      model.paintData.estimatesPerRoom.forEach(function (estimatePerRoom) {
        viewModel.modalData.estimateData.estimatesPerRoom.push(estimatePerRoom);
      });
    },
    init: function init() {
      viewModel.initSheenData();
      viewModel.initParentBrandData();
      viewModel.setPaintData(model.paintData);
    }
  };
  function setDiscontinuedSelectAnotherOptionMsg() {
    $('#selectAnotherOptionMsg').html('Please select another option below.');
  }
  return {
    init: function init() {
      model.init();
      viewModel.init();
      view.init();
      setDiscontinuedSelectAnotherOptionMsg();
    },
    view: view,
    model: model,
    viewModel: viewModel
  }
});

}.call(window));